export default {
  namespaced: true,
  procedure_states: {
    scheduled: "Programado",
    in_progress: "Em Progresso",
    in_review: "Em Revisão",
    reopened: "Reasignado",
    rejected: "Rejeitado",
    approved: "Aprovado",
    cancelled: "Cancelado",
    canceled: "Cancelado",
    completed: "Completado",
    review: "Em Revisão",
    value: {
      scheduled: "Programado",
      in_progress: "Em Progresso",
      in_review: "Em Revisão",
      rejected: "Rejeitado",
      approved: "Aprovado",
      cancelled: "Cancelado",
      canceled: "Cancelado",
      reassigned: "Reatribuído",
      completed: "Completado",
      review: "Em Revisão"
    },
  }
}
